import styled, { keyframes } from 'styled-components';

interface CheckboxProps {
  isFilled: boolean;
}

const appearOpacity = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

export const Container = styled.div`
  flex: 1;

  padding: 10rem 0;

  animation: ${appearOpacity} 180ms ease-in;
`;

export const Header = styled.header`
  display: flex;
  align-items: center;

  height: 10rem;
  width: 100%;

  position: fixed;
  top: 0;

  .logo-container {
    display: flex;
    align-items: center;
    justify-content: center;

    background: #242424;

    height: 100%;
    width: 10rem;
  }

  > nav {
    display: flex;
    align-items: center;

    background: #ffdf22;
    flex: 1;
    height: 100%;

    padding: 3rem 2rem;

    @media (min-width: 768px) {
      padding: 3rem 5.6rem;
    }

    > h1 {
      font-weight: ${({ theme }) => theme.fontWeight.LatoBold};
      font-size: 2.4rem;
      letter-spacing: 1.6px;
      text-transform: uppercase;
      color: ${({ theme }) => theme.colors.black};

      @media (min-width: 425px) {
        font-size: 3.2rem;
      }
    }
  }
`;

export const Content = styled.main`
  background: ${({ theme }) => theme.colors.white};

  padding: 2rem;
  flex: 1;

  @media (min-width: 768px) {
    padding: 4.6rem 10.2rem;
  }

  > p {
    color: #43434a;
    text-align: justify;
  }
`;

export const Footer = styled.footer`
  display: block;
  align-items: center;
  justify-content: space-between;

  position: fixed;
  bottom: 0;

  background: #242424;
  width: 100%;

  padding: 2rem;

  @media (min-width: 425px) {
    display: flex;
  }

  @media (min-width: 768px) {
    padding: 2.2rem 6rem 2.2rem 5.6rem;
    height: 10rem;
  }

  > button {
    max-width: 38.7rem;
    width: 100%;
  }
`;

export const CheckboxContainer = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;

  background: none;

  margin-bottom: 2rem;
  margin-right: 1rem;

  > span {
    margin-left: 0.8rem;
    color: ${({ theme }) => theme.colors.white};
  }

  @media (min-width: 425px) {
    margin-bottom: 0;
    justify-content: left;
  }
`;

export const Checkbox = styled.div<CheckboxProps>`
  height: 2rem;
  min-width: 2rem;

  background: ${({ theme, isFilled }) =>
    isFilled ? theme.colors.yellow : theme.colors.white};
  box-shadow: 0px 1px 4px #0000001a;

  border: 0.3px solid #dbdbdb;
  border-radius: 0.6rem;

  cursor: pointer;

  transition: 180ms ease-in;
`;
